

import Post from './components/Post';
import SideNav from './components/SideNav';
import Suggestion from './components/Suggestion';

function App() {
  return (
    <div className="App">
     
      <SideNav/>
      <Suggestion/>
      <Post/>
   
    



   
    </div>
  );
}

export default App;
